import { RecorderHealthMoreDetailInterface } from "api/interfaces/reportInterface.interface";
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";
import { useState } from "react";
import { IoChevronDownOutline, IoChevronUp } from "react-icons/io5";
import ResponsiveMobileMenu from "./ResponsiveHealthMenu";
import { HealthMenuItem } from "../HealthStyled";

type Props = {
  isCurrentMenu: number;
  onChangeMenu: (index: number) => void;
  menus: Array<RecorderHealthMoreDetailInterface>;
};

export const statusToColor = (status?: string) => {
  if (status === "ALERT") {
    return COLORS.PROGRESSBAR;
  }
  if (status === "WARNING") {
    return COLORS.WARNING;
  }
};
export const upperStatus = (status?: string) => {
  return status?.toUpperCase();
};
export default function HealthMenus(props: Props): JSX.Element {
  const currentMenu = props.menus[props.isCurrentMenu];

  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <mediaQuery.Desktop>
        <Container>
          {props.menus.map((item, index) => (
            <HealthMenuItem
              key={index}
              isCurrent={props.isCurrentMenu === index}
              onClick={() => props.onChangeMenu(index)}
              status={upperStatus(item.status)}
              data-testid={`reports-view-component-health-menu-${index}`}
            >
              <div className="alert-wrapper"></div>
              <div className="health-menu-icon-wrapper">{item.icon}</div>
              <div className="health-menu-label-wrapper">
                <span className="label">{item.label}</span>
                {item.value && (
                  <Value status={upperStatus(item.status)}>
                    {item.subLabel
                      ? `${item.value} ${item.subLabel}`
                      : item.value}
                  </Value>
                )}
              </div>
            </HealthMenuItem>
          ))}
        </Container>
      </mediaQuery.Desktop>

      <mediaQuery.Tablet>
        <ResponsiveMobileMenu
          currentMenu={currentMenu}
          menus={props.menus}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          onChangeMenu={props.onChangeMenu}
        />
      </mediaQuery.Tablet>
      <mediaQuery.Mobile>
        <ResponsiveMobileMenu
          currentMenu={currentMenu}
          menus={props.menus}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          onChangeMenu={props.onChangeMenu}
        />
      </mediaQuery.Mobile>
    </>
  );
}

const Container = styled.ul`
  ${FLEX.FlexBetweenCenter};
  gap: 10px;
  flex-direction: column;
  width: 100%;
  grid-area: menu;
  max-height: 680px;
  /* min-width: 340px;
  max-width: 340px; */
  white-space: nowrap;
  margin-right: -15px;
`;

export const Value = styled.span<{ status?: string }>`
  color: #828b9b;
  color: ${({ status }) => statusToColor(status)};
  color: ${({ status }) => status === "HEALTHY" && COLORS.BUTTONS2};

  ${mediaQuery.isMobile} {
    font-size: ${calcRem(14)};
  }
`;
